import apiV2 from '../api/v2';

// Accounts > Practice detail > Overview tab's stats strip. Combined
// (non-generation-split) patient counts for one practice - the design's
// separate V1/V2 sub-lines and segmented control were explicitly dropped.
export interface PracticeStats {
    total: number;
    inTreatment: number;
    onHold: number;
    pendingAction: number;
    completed: number;
}

export async function fetchPracticeStats(practiceId: string): Promise<PracticeStats> {
    const response = await apiV2.get<{ success: boolean; data: PracticeStats }>(
        `/practices/${practiceId}/stats`
    );
    return response.data.data;
}
